import React from 'react';
import { StyleSheet, TextInput } from 'react-native';
import { Colors } from 'react-native-paper';
import { pixelDimensions } from '../../config/utils';

function AppInput({ style, ...props }) {
  return (
    <TextInput
      style={[styles.text, style]}
      {...props}
    />
  );
}

const styles = StyleSheet.create({
  text: {
    backgroundColor: Colors.grey200,
    color: Colors.grey700,
    borderColor: Colors.grey700,
    borderWidth: 3,
    height: pixelDimensions(9),
    fontSize: pixelDimensions(4),
    padding: pixelDimensions(2),
    fontFamily: 'MRegular',
  },
});

export default AppInput;
